import * as i from 'io-ts';
import { Pose } from '../../../pose';
/**
 * Another Particle can be attached at a Slot.
 *
 * This is only valid if the Particle has a tag which is in the list of applicableTags.
 */
export const Slot = i.type({
    applicableTags: i.array(i.string),
    attachmentPoints: i.array(Pose),
    name: i.string,
    onlyAttachmentPointOptionForApplicableTags: i.boolean,
});
export const isApplicable = (slot, tag) => slot.applicableTags.includes(tag);
